<!-- maby?? -->
<div id="modal-content-wrapper" >
    <div>
        <header id="modal-header">
            <h1 i18n id="modal-title">Make your choice</h1>
        </header>
        <div class="modal-state-button-container">
            <div class="status-bar-container">
                <div class="status-row">
                  <button class="status-ball space-right" (click)="selectState(0)" [ngStyle]="state >=0?{'background-color':'#B6C1B1' } : {'color':'#B6C1B1'}" >
                    <p i18n >Products</p>
                  </button>
                  <button class="status-ball space-right" (click)="selectState(1)" [ngStyle]="state >= 1?{'background-color':'#B6C1B1' } : {'color':'#B6C1B1'}">
                    <p i18n >Order preview</p>
                  </button>
                  <button class="status-ball space-right" (click)="selectState(2)" [ngStyle]="state >= 2?{'background-color':'#B6C1B1' } : {'color':'#B6C1B1'}" [disabled]="!confirmed">
                    <p i18n >Details and shipping</p>
                  </button>
                  <button class="status-ball " (click)="selectState(3)" [ngStyle]="state >= 3?{'background-color':'#B6C1B1' } : {'color':'#B6C1B1'}" [disabled]="true">
                    <p i18n >Payment</p>
                  </button>
                </div>
                <div class="status-row">
                  <div class="status-line" [ngStyle]="state >= 1?{'background-color':'#B6C1B1' } : {}">
                  </div>
                  <div class="status-line" [ngStyle]="state >= 2?{'background-color':'#B6C1B1' } : {}">
                  </div>
                  <div class="status-line" [ngStyle]="state >= 3?{'background-color':'#B6C1B1' } : {}">
                  </div>
                </div>
              </div>
        </div>
        <div *ngIf="state == 0">
            <div class="content-container article-settings-container">
                <div class="attribute-form-container">
                    <h2 i18n>Select product:</h2>
                    <form (ngSubmit)="next()" class="attribute-select-container">
                        <div *ngFor="let attribute of attributes; let i = index" >  
                            <form [formGroup]="attribute" *ngIf="attribute.value.attribute_id != 11">
                                <label for="attribute">{{attribute.value.title}}</label>
                                <select formControlName="selected" id="attribute" (change)="articleAttributes()">
                                    <option i18n  *ngFor="let attributeValue of attribute.value.attributeValues; let i = index" [value]="attributeValue.attribute_value_id">
                                        {{attributeValue.attribute_value_culture}}
                                    </option>
                                </select>
                            </form>
                        </div>
                    </form>
                </div>
                <div class="article-info-container">
                    <div class="attribute-info-container">
                        <h2 i18n>Product:</h2>
                        <div *ngFor="let attribute of articleAttributeList; let i = index" class="attribute-field">  
                            <p i18n class="attribute-name"  *ngIf="attribute.attribute_id != 11">{{attribute.attributeName}}:   </p> <p i18n >{{attribute.attributeValue}}</p>
                        </div>
                    </div>
                    <div class="attribute-field">  
                        <p i18n  class="attribute-name">Price:</p> <p><app-currency-converter [data]="{price:price.price, country: null}"></app-currency-converter></p>
                    </div>
                </div>
            </div>
            
            <div class="button-container">
                <button i18n mat-raised-button id="next-button" (click)="selectState(state+1)">
                    Next
                </button>
            </div>
        </div>
        <div *ngIf="state == 1" class="content-container">
            <app-shopping [article]="orderArticle" (event)="receiveConfirmation($event)"></app-shopping>
        </div>
        <div *ngIf="state == 2" class="content-container">
            <app-customer-info [article]="orderArticle" (orderEmitter)="fwdOrder($event)"></app-customer-info>
        </div>
        <div *ngIf="state == 3" class="content-container">
            <app-checkout [order]="order"></app-checkout>
        </div>
    </div>
    <footer id="modal-footer">
        <button i18n *ngIf="state > 0" (click)='selectState(state-1)' class="back-button">Back</button>
        <button i18n  mat-dialog-close>Cancel order</button>
    </footer>
</div>